import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { SearchIcon } from '../../../SvgIconsV3/Search';
import COLORS3 from '../../../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../../../styles/emotion/mediaQueryV2';
import FormTooltip from '../../common/FormTooltip';
import Hashtag from '../../../SvgIcons/Hashtag';
import Cash from '../../../SvgIcons/Cash';
import Calendar from '../../../SvgIcons/CalendarDay';
import GeoPin from '../../../SvgIcons/GeoPin';
import LinkIcon from '../../../SvgIcons/Link';
import Remove from '../../../SvgIcons/Remove';
import { AtIcon } from '../../../SvgIconsV3/At';
import type { State } from '../../form.styles';
import { inputBaseStyles, FormLabel, fieldHeight, fieldHeightMobile } from '../../form.styles';
import { UserSearchIcon } from '../../../SvgIconsV3/UserSearch';

export const Input = styled.input<{
  state?: State;
}>`
  height: ${fieldHeight}px;
  ${MEDIA_QUERY_V2.MOBILE} {
    height: ${fieldHeightMobile}px;
  }
  ${({ state }) => inputBaseStyles(state)}
`;

export const InputSection = styled.div`
  position: relative;
`;

export const InputFieldContainer = styled.div<{
  inline?: boolean;
  alignment: 'vertical' | 'horizontal';
  hasLabel?: boolean;
}>`
  ${(p) => p.inline && `display: inline-block`};
  ${({ alignment, hasLabel }) => {
    if (alignment === 'horizontal') {
      return `display: flex;
      ${FormLabel} {
        line-height: ${fieldHeight}px;
        ${MEDIA_QUERY_V2.MOBILE} {
          line-height: ${fieldHeightMobile}px;
        }
      }
      ${InputSection} {
        margin-left: 8px;
      }`;
    }

    return `${InputSection} {
        margin-top: ${hasLabel ? '8px' : '4px'};
      }`;
  }}
  svg {
    color: var(--text-primary);
  }
`;

export const OptionalText = styled.span`
  color: var(--text-tertiary, ${COLORS3.BLACK_050});
`;

export const StyledFormTooltip = styled(FormTooltip)`
  margin-left: 5px;
`;

const getInputAddOnStyling = (iconSize = 16) => css`
  width: ${iconSize}px !important;
  height: ${iconSize}px !important;

  position: absolute;
  // Center icon addon vertically according to size
  top: ${fieldHeight / 2 - iconSize / 2}px;
  ${MEDIA_QUERY_V2.MOBILE} {
    top: ${fieldHeightMobile / 2 - iconSize / 2}px;
  }
  left: 13px;

  + ${Input} {
    padding-left: ${iconSize + 21}px;
  }
`;

export const HashtagAddOn = styled(Hashtag)`
  ${getInputAddOnStyling()}
`;

export const CashAddOn = styled(Cash)`
  ${getInputAddOnStyling()}
`;

export const GeoPinAddOn = styled(GeoPin)`
  ${getInputAddOnStyling(14)}
`;

export const LinkAddOn = styled(LinkIcon)`
  ${getInputAddOnStyling()}
`;

export const CalendarAddOn = styled(Calendar)`
  ${getInputAddOnStyling(18)}
`;

export const CoupleSearchAddOn = styled(UserSearchIcon)`
  ${getInputAddOnStyling(18)}
`;

export const SearchAddOn = styled(SearchIcon)`
  ${getInputAddOnStyling()}
`;

export const AtAddOn = styled(AtIcon)`
  ${getInputAddOnStyling()}
`;
const clearIconSize = 12;
export const ClearIconContainer = styled.button`
  align-items: center;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-flow: row;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 14px;
  color: var(--text-primary, ${COLORS3.BLACK_100});
  ${MEDIA_QUERY_V2.MOBILE} {
    top: ${(fieldHeightMobile - fieldHeight) / 2 + clearIconSize}px;
  }
  ${Input} {
    padding-right: ${clearIconSize + 12 + 4}px;
  }
`;
export const ClearIcon = styled(Remove)`
  height: ${clearIconSize}px !important;
  width: ${clearIconSize}px !important;
`;

export const EyeIconContainer = styled('span')`
  width: ${clearIconSize}px !important;
  height: ${clearIconSize}px !important;
  position: absolute;
  top: 14px;
  right: 12px;
  ${MEDIA_QUERY_V2.MOBILE} {
    top: ${(fieldHeightMobile - fieldHeight) / 2 + clearIconSize}px;
  }
  ${Input} {
    padding-right: ${clearIconSize + 12 + 4}px;
  }
`;
